export default class Channel {
  constructor(
    bio = null,
    categories = [],
    city = null,
    channel_name = '',
    channel_image = null,
    name = '',
    picture = null,
    specialties = [],
    sports = [],
    tags = [],
    user_id = null,
    username = null,
    video = '',
    website = null,
    trainer_relationship = null,
  ) {
    this.bio = bio;
    this.categories = categories;
    this.city = city;
    this.channel_name = channel_name;
    this.channel_image = channel_image;
    this.name = name;
    this.picture = picture;
    this.specialties = specialties;
    this.sports = sports;
    this.tags = tags;
    this.user_id = user_id;
    this.username = username;
    this.video = video;
    this.website = website;
    this.trainer_relationship = trainer_relationship;
  }
}
